var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgPlay56 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 56,
  height: 56,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m45.555 27.168-30-20A1 1 0 0 0 14 8v40a1 1 0 0 0 1.555.832l30-20a1 1 0 0 0 0-1.664Z"
})));
export { SvgPlay56 as ReactComponent };
export default __webpack_public_path__ + "6b52fa132feb61d7e6ab797c4436c869.svg";